import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { Alert } from "react-bootstrap";
import Loading from "../Loading";
import { Link } from "react-router-dom";

function EventInviteCard({ eventInvite }) {
    const [event, setEvent] = useState(null);
    const [error, setError] = useState(null);
    if (!eventInvite) {
        return null;
    }

    const getEvent = useCallback(async () => {
        try {
            const response = await axios.post("/getEvent", {
                eventId: eventInvite.eventId,
            });
            setEvent(response.data.event);
        } catch(requestError) {
            console.error(requestError);
            setError("Er ging iets fout bij het ophalen van het evenement. Probeer het later opnieuw.");
        }
    }, [eventInvite]);

    useEffect(() => {
        getEvent();
    }, [getEvent]);

    return (
        <React.Fragment>
            {error ? (
                <Alert variant="danger">{error}</Alert>
            ) : !event ? (
                <Loading white />
            ) : (
                <div className="card mb-3">
                    <div className="card-body d-flex flex-row justify-content-between align-items-center">
                        <div>
                            <h5 className="card-title">Jouw aanmelding voor {event.name} is geaccepteerd!</h5>
                            <p className="card-text">Klik op de knop hiernaast om jouw deelname compleet te maken.</p>
                        </div>
                        <Link to={`/accept-invite/${eventInvite.token}`} className="btn btn-primary">Uitnodiging accepteren</Link>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

EventInviteCard.propTypes = {
    eventInvite: PropTypes.object.isRequired,
};

export default React.memo(EventInviteCard);
